import BaseModule from '../../../../javascripts/helpers/baseModule';
import addClass from '../../../../javascripts/dom/addClass';

export default class Calendar extends BaseModule {
  constructor(element, selector) {
    super(element, selector);

    this.getElements([
      {
        selector: 'link',
        id: 'link'
      }
    ]);

    const { link } = this.elements;
    const eventList = document.getElementById('events--list-calendar');

    element.querySelectorAll('.event-calendar__day-link').forEach(linkElement => {
      // eslint-disable-next-line func-names
      linkElement.addEventListener('click', event => {
        event.preventDefault();


        const selectedDate = linkElement.dataset.date;
        element.querySelectorAll('a.active').forEach(el => {
          el.classList.remove('active');
        });

        linkElement.classList.toggle('active');

        eventList.querySelectorAll('.events--list-item').forEach(el => {
          el.classList.remove('active');
        });

        eventList.querySelectorAll(`[data-date="${selectedDate}"]`).forEach(el => {
          el.classList.add('active');
        });

        eventList.scrollIntoView({ behavior: 'smooth' });
      });
    });

    element.querySelectorAll('.has-events.event-calendar__day-today').forEach(el => {
      el.getElementsByClassName('event-calendar__day-link')[0].click();
    });
  }
}
